import React from 'react';
import Styled from './styled';
import { ANNOUNCEMENTS_TYPE } from '../../../constants/ANNOUNCEMENT';

export const SidebarTypeFilter = (props) => {
  const { selectedFilter, children, type, onSelect, setSubSelectedFilter } = props;
  const { filters } = window.Widget.announcementsController;

  const handleClick = () => {
    onSelect(type);

    if (type !== ANNOUNCEMENTS_TYPE.ALL) {
      setSubSelectedFilter(ANNOUNCEMENTS_TYPE.ALL);
    }
  };

  if (!filters[type]) {
    return null;
  }

  return (
    <Styled.TypeFilterBtn onClick={handleClick} isActive={selectedFilter === type}>
      {children}
    </Styled.TypeFilterBtn>
  );
};
